import { makeStyles } from '@mui/styles';
import { orange } from 'apollo-react/colors';
import Typography from 'apollo-react/components/Typography';
import Export from 'apollo-react-icons/Export';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    color: orange,
  },
  icon: {
    width: '16px',
    height: '16px',
    marginRight: '3px',
  },
  label: {
    color: orange,
    fontSize: '12px',
    fontWeight: '500',
  },
});

const TaskStatusCardPortalLabel = () => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <div className={classes.root}>
      <Export className={classes.icon} />
      <Typography className={classes.label} variant="caption">
        {translateString('Routed to portal')}
      </Typography>
    </div>
  );
};

export default TaskStatusCardPortalLabel;
